import type { BatchQueue } from './batch-queue'

import { createContext, useContext } from 'react'

/**
 * Holds the active {@link BatchQueue} for the subtree under a
 * `SormBatchProvider`. `null` (no provider mounted) means queries run
 * un-batched — one `/sorm/query` request each, today's behavior.
 */
export const SormBatchContext = createContext<BatchQueue | null>(null)

/**
 * Read the active SORM batch queue, or `null` when no `SormBatchProvider` is
 * mounted above the caller. The data-access query hooks pass the result into
 * their `queryFn`; when `null` they fall back to issuing one request per query.
 */
export function useSormBatchQueue(): BatchQueue | null {
  return useContext(SormBatchContext)
}
